export default [{ path: 'user', component: () => import('pages/user/user') }];
